import values from 'lodash/values';
import invert from 'lodash/invert';
import snakeCase from 'lodash/snakeCase';

import LayoutCommon from "../../visComponents/layoutCommon";

import Appliance from "./parts/appliance";
import Cabinet from "./parts/cabinet";
import CenterIsland from "./parts/centerIsland";
import CountertopGroup from "./parts/countertopGroup";
import Walls from "./parts/walls";
import FloorNew from "./parts/floorNew";
import Globals from "./parts/globals";

import {LayoutType, LayoutAbbreviation} from "./constants";
import {LayoutThumbnails} from "./assets";
import Z from "./zIndex";
import store from "../../../store";
import * as types from "../../../actions/actionTypes";
import Other from "./parts/other";
import NonVisualizerSubPart from "./subparts/nonVisualizerSubPart";
import DesignNavigationItem from "../../visComponents/designNavigationItem";
import Layer from "../../visComponents/layer";
import {largeLayoutShadow, SmallLayoutShadow} from "./assets";
// import {featureThumbnailUrl} from "../../../misc/helpers";
import {AVAILABLE_VISUALIZER_TYPES} from "../../../config";

export class Layout extends LayoutCommon {

  /**
   * @type {int}
   */
  defaultType = LayoutType.LShapeWithPeninsulaWithIsland;
  type = this.defaultType;
  visualizerType = AVAILABLE_VISUALIZER_TYPES.Kitchen;
  localStorageKey = "kvState";
  layersBinding = "Kitchen";
  layoutNames = LayoutAbbreviation;
  layoutTypes = LayoutType;
  layoutThumbnails = LayoutThumbnails;
  zIndexes = Z.layouts;

  constructor(props) {
    super(props);
    this.parts[Appliance.id] = new Appliance();
    this.parts[Cabinet.id] = new Cabinet();
    this.parts[CenterIsland.id] = new CenterIsland();
    this.parts[CountertopGroup.id] = new CountertopGroup();
    this.parts[Walls.id] = new Walls();
    this.parts[FloorNew.id] = new FloorNew();
    this.parts[Globals.id] = new Globals();
    this.parts[Other.id] = new Other();

    values(this.parts).forEach(part => part.layout = this);
  }

  addCustomLayers = (res) => {
    // add global shadow
    const globalShadowParent = this.parts[Globals.id]; // if no global shadow uploaded - take the hardcoded one
    if (!globalShadowParent.categoryEnabled || !globalShadowParent.globalShadow || !globalShadowParent.globalShadow.activeFeature) {
      if (this.getCurrentLayoutAbbreviation().includes("L")) {
        res.push(new Layer("kv", Z.layouts.LShape.Globals.GlobalShadow, largeLayoutShadow, false));
      } else if (this.type === LayoutType.Small) {
        res.push(new Layer("kv", Z.layouts.Small.Globals.GlobalShadow, SmallLayoutShadow, false));
      }
    }
    return res
  }

  getCurrentLayoutName(type = this.type) {
    return invert(LayoutType)[type];
  }

  getCurrentLayoutAbbreviation() {
    return LayoutAbbreviation[this.getCurrentLayoutName()]
  }

  // getActiveFeatures(returnAllFeatures) { // removed, we have common now
  //   let activeFeatures = [];
  //   const receiveAllFeatures = returnAllFeatures || !!(this.qtCategories && this.qtCategories.length);
  //   this.getFeatures(receiveAllFeatures).forEach((parentGroup) => {
  //     // let subParts = parentGroup.subParts().filter(subPart => !subPart.part.disabled); // we need to store every item!
  //     if (parentGroup.menuType === 0) { // FLOOR
  //       if (!parentGroup.disabled && parentGroup.activeFeature
  //         && !parentGroup.activeFeature.partName.includes("laceholder")) {
  //         activeFeatures.push({
  //           selectionGroup: parentGroup.partName,
  //           partId: parentGroup.partId,
  //           quantity: 0,
  //           cartFeature: parentGroup.activeFeature
  //         });
  //       }
  //     } else {
  //       let subItems = parentGroup.relatedItems;
  //       const excluded = ["fridge_shadow"];
  //       if (!returnAllFeatures) {
  //         subItems = subItems.filter(subItem => !excluded.includes(subItem.partId) && subItem.activeFeature
  //             && subItem.activeFeature.partName && !subItem.activeFeature.partName.includes("laceholder"));
  //       }
  //       subItems.forEach((subItem) => {
  //         //adding top cabinet parts to cart features //Alan 25.07.2019
  //         if (subItem.partId === "top_cabinet" && subItem.activeFeature && subItem.activeFeature.metaData["Module"]) {
  //           let uniqueModuleParts = []; // arrayOf: {width: "", height: "", inlayTypeName: "", quantity: 0}
  //           for (let i = 1; i <= subItem.moduleSystem.length; i++ ) {
  //             const currentModuleSystemNumber = i - 1;
  //             for (let k = 0; k <= subItem.moduleSystem[currentModuleSystemNumber].length - 1; k++ ) {
  //               const modulePart = subItem.moduleSystem[currentModuleSystemNumber][k];
  //               const modulePartSplitted = modulePart.split("_");
  //
  //               let inlayTypeName = subItem.defaultInlayType;
  //               subItem.inlayTypes.forEach(inlayType => {
  //                 if (inlayType.moduleParts.includes(i + "_" + modulePartSplitted[2])) {
  //                   inlayTypeName = inlayType.name
  //                 }
  //               });
  //
  //               const existingModulePart = uniqueModuleParts.find((uniqueModulePart) => {
  //                 return uniqueModulePart.width === modulePartSplitted[0]
  //                   && uniqueModulePart.height === modulePartSplitted[1]
  //                   && uniqueModulePart.inlayTypeName === inlayTypeName
  //               });
  //               if (existingModulePart) {
  //                 existingModulePart.quantity++;
  //               } else {
  //                 const cartFeature = subItem.findFeatureByModuleAndModulePart(modulePart, inlayTypeName);
  //                 if (cartFeature) {
  //                   uniqueModuleParts.push({
  //                     width: modulePartSplitted[0],
  //                     height: modulePartSplitted[1],
  //                     inlayTypeName,
  //                     cartFeature,
  //                     quantity: 1,
  //                     partName: subItem.activeFeature.partName
  //                   })
  //                 }
  //               }
  //             }
  //           }
  //           // console.log("uniqueModuleParts", uniqueModuleParts);
  //           uniqueModuleParts.forEach((uniqueModulePart, uniqueModulePartIndex) => {
  //             activeFeatures.push({
  //               selectionGroup: parentGroup.partName,
  //               partId: subItem.partId + "_module_" + uniqueModulePartIndex,
  //               // partId: subItem.partId,
  //               cartFeature: uniqueModulePart.cartFeature,
  //               thumbnail: featureThumbnailUrl(subItem.activeFeature),
  //               partName: uniqueModulePart.partName,
  //               description: `Width: <span class="text-brown">${uniqueModulePart.width}</span> Height: <span class="text-brown">${uniqueModulePart.height}</span> Inlay Type: <span class="text-brown">${uniqueModulePart.inlayTypeName}</span>`,
  //               quantity: uniqueModulePart.quantity
  //             });
  //           });
  //         }
  //         if (subItem.activeFeature) {
  //           activeFeatures.push({
  //             selectionGroup: parentGroup.partName,
  //             partId: subItem.partId,
  //             quantity: 0,
  //             cartFeature: subItem.activeFeature
  //           });
  //         }
  //       })
  //     }
  //   });
  //   // console.log('activeFeatures', activeFeatures);
  //   if (!returnAllFeatures && this.qtCategories && this.qtCategories.length) {
  //     activeFeatures = activeFeatures.filter(activeFeature => {
  //       return this.qtCategories.some(qtCategory => qtCategory.subParts.some(subPart => {
  //         return subPart.part.partId === activeFeature.partId
  //       }))
  //     })
  //   }
  //   return activeFeatures
  // }

  /**
   *
   * @param bvState {object}
   * @param setCartAndUserState {boolean | array} // only in the parseResponse function (when job is opened in the dashboard)
   * @param useNames {boolean}
   * @param needToChangeLayout {boolean}
   * @param firstLoad {boolean}
   */
  setActiveFeaturesFromObject(bvState, setCartAndUserState = false, useNames = false, needToChangeLayout = true, firstLoad = false) {
    if (bvState) {

      const cabinetParent = this.parts[Cabinet.id];
      const countertopGroupParent = this.parts[CountertopGroup.id];

      const layout_type = +bvState.layout_type;
      needToChangeLayout = needToChangeLayout && (layout_type || layout_type === 0) && (layout_type !== +this.type);

      if (needToChangeLayout) {
        this.type = layout_type;
      }

      // to avoid checks below
      bvState.disabled_parts = bvState.disabled_parts || [];

      this.getFeatures()
        .forEach((parentGroup) => {
          if (parentGroup.menuType === 0) {
            const partId = parentGroup.partId;
            const hasPreviouslySavedItem = this.selectedLayoutFeatures[layout_type]
              && this.selectedLayoutFeatures[layout_type][partId];
            if (bvState.hasOwnProperty(partId) || hasPreviouslySavedItem) {
              if (useNames) {
                parentGroup.activeFeature = parentGroup.getFeatureByPartName(bvState[partId]);
                if (!parentGroup.activeFeature && hasPreviouslySavedItem) {
                  parentGroup.activeFeature = parentGroup.getFeatureByPartName(hasPreviouslySavedItem);
                }
              } else {
                parentGroup.activeFeature = parentGroup.getFeatureById(bvState[partId])
                  || parentGroup.getDefaultFeature();
              }
              parentGroup.placeholderChanged = !!parentGroup.activeFeature;
              // const {activeQuoteIndex} = store.getState().quotesState;
              // parentGroup.firstClick[activeQuoteIndex] = !!parentGroup.activeFeature;
            }
            if (parentGroup.activeFeature && firstLoad && !parentGroup.activeFeature.notAvailableInVisualizer) { // Leave non in vis features locked
              parentGroup.activeFeature.dbFeature.unlocked = true;
            }
            if (bvState.disabled_parts.includes(partId)) {
              parentGroup.disabled = true
            }
          } else {
            let relatedItems = parentGroup.getRelatedItems();
            relatedItems.forEach((subPart) => {
              const partId = subPart.partId;
              let previouslySelectedItem = null;
              subPart.selectedFeaturesHistory.some(featureName => {
                previouslySelectedItem = subPart.getFeatureByPartName(featureName);
                return previouslySelectedItem
              });
              if (bvState.hasOwnProperty(partId) || previouslySelectedItem) {
                if (useNames) {
                  const matchingFeature = (partId === "backsplash" && bvState["backsplash_type"])
                    ? subPart.getFeatureByBacksplashType(bvState["backsplash_type"], bvState["backsplash"])
                    : subPart.getFeatureByPartName(bvState[partId]);
                  if (matchingFeature) {
                    subPart.activeFeature = matchingFeature;
                  } else if (previouslySelectedItem) {
                    subPart.activeFeature = previouslySelectedItem;
                  }
                } else {
                  subPart.activeFeature = subPart.getFeatureById(bvState[partId]) || parentGroup.getDefaultFeature();
                }
                subPart.placeholderChanged = !!subPart.activeFeature;
                // const {activeQuoteIndex} = store.getState().quotesState;
                // subPart.firstClick[activeQuoteIndex] = !!subPart.activeFeature;
                // if (subPart.firstClick) {
                //   console.log("subPart.firstClick", subPart);
                // }
              }
              if (subPart.activeFeature && firstLoad && !subPart.activeFeature.notAvailableInVisualizer) {
                subPart.activeFeature.dbFeature.unlocked = true;
              }
              if (bvState.disabled_parts.includes(partId)) {
                subPart.disabled = true
              }
            })
          }
        });

      const partPredicate = (part, value) => useNames ? part.partName === value : +part.dbFeature.id === +value;
      Object.keys(bvState)
        .forEach((bvStateKey) => {
          let partId, parent, relatedName;
          switch(bvStateKey) {
            case "top_cabinet_parts":
              partId = "top_cabinet_parts";
              parent = cabinetParent;
              relatedName = "topCabinet";
              break;
            case "bottom_cabinet_parts":
              partId = "bottom_cabinet_parts";
              parent = cabinetParent;
              relatedName = "bottomCabinet";
              break;
            case "crown_molding":
              partId = "crown_molding_parts";
              parent = cabinetParent;
              relatedName = "crownMolding";
              break;
            case "countertop_parts":
              partId = "countertop_parts";
              parent = countertopGroupParent;
              relatedName = "countertop";
              break;
            default:
              break;
          }
          if (parent && bvState[partId] && bvState[partId].length && parent[relatedName]) {
            const relatedItem = parent[relatedName];
            // if (bvStateKey === "top_cabinet_parts" || bvStateKey === "bottom_cabinet_parts") {
            //   bvState[partId] = Array.isArray(bvState[bvStateKey])
            //     ? bvState[bvStateKey]
            //     : JSON.parse(decodeURIComponent(bvState[bvStateKey]));
            // }
            const matchingParts = bvState[partId]
              .map((featureId) => {
                const arrayOfItems = (relatedItem.moduleParts)
                  ? [...relatedItem.featuresParts, ...relatedItem.moduleParts]
                  : relatedItem.featuresParts;
                return arrayOfItems.find(_ => partPredicate(_, featureId));
              })
              .filter((featuresPart) => {
                return featuresPart && featuresPart.matchesMetaForArrayOfConditions(relatedItem.getArrayOfConditions());
              });
            if (matchingParts.length) {
              relatedItem.activeFeatureParts = matchingParts
            }
            if (bvStateKey === "top_cabinet_parts" && bvState["top_module_system"]) {
              relatedItem.moduleSystem = Array.isArray(bvState["top_module_system"])
                ? bvState["top_module_system"]
                : JSON.parse(decodeURIComponent(bvState["top_module_system"]));
              if (bvState["inlay_types"]) {
                relatedItem.inlayTypes = Array.isArray(bvState["inlay_types"])
                  ? bvState["inlay_types"]
                  : JSON.parse(decodeURIComponent(bvState["inlay_types"]));
              }
              relatedItem.activeFeatureParts = relatedItem.setActiveFeatureParts();
            } else if (bvStateKey === "bottom_cabinet_parts" && bvState["bottom_module_system"]) {
              relatedItem.moduleSystem = Array.isArray(bvState["bottom_module_system"])
                ? bvState["bottom_module_system"]
                : JSON.parse(decodeURIComponent(bvState["bottom_module_system"]));
              relatedItem.activeFeatureParts = relatedItem.setActiveFeatureParts();
            }
          }
        });

      if (needToChangeLayout) {
        this.changeLayout(this.getFeatures());
      }

      if (setCartAndUserState) {
        this.setCartStateAndUserStateFromBvState(bvState, setCartAndUserState);
      }

      const layoutParts = this.designNavigationItems()
        .filter(parentGroup => parentGroup.part.categoryEnabled)
        .map((parentGroup) => parentGroup.part.partName);

      if (!this.isFakeLayout) {
        store.dispatch({
          type: types.SET_LAYOUT_DATA_PARTS,
          payload: {layoutParts}
        });
      }

    }
  }

  /**
   * Sets bv features from url
   */

  parseUrl(bvState) {
    if (bvState.disabled_parts) {
      bvState.disabled_parts = bvState.disabled_parts.split(",");
    }
    if (bvState.top_cabinet_parts) {
      bvState.top_cabinet_parts = Number.isInteger(bvState.top_cabinet_parts)
        ? [bvState.top_cabinet_parts]
        : bvState.top_cabinet_parts.split(",")
      // bvState.top_cabinet_parts = JSON.parse(decodeURIComponent(bvState.top_cabinet_parts));
    }
    if (bvState.bottom_cabinet_parts) {
      bvState.bottom_cabinet_parts = Number.isInteger(bvState.bottom_cabinet_parts)
        ? [bvState.bottom_cabinet_parts]
        : bvState.bottom_cabinet_parts.split(",")
      // bvState.bottom_cabinet_parts = JSON.parse(decodeURIComponent(bvState.bottom_cabinet_parts));
    }
    if (bvState.crown_molding_parts) {
      bvState.crown_molding_parts = Number.isInteger(bvState.crown_molding_parts)
        ? [bvState.crown_molding_parts]
        : bvState.crown_molding_parts.split(",")
    }
    if (bvState.countertop_parts) {
      bvState.countertop_parts = Number.isInteger(bvState.countertop_parts)
        ? [bvState.countertop_parts]
        : bvState.countertop_parts.split(",")
    }
    if (bvState.top_module_system) {
      bvState.top_module_system = JSON.parse(decodeURIComponent(bvState.top_module_system))
    }
    if (bvState.inlay_types) {
      bvState.inlay_types = JSON.parse(decodeURIComponent(bvState.inlay_types))
    }
    if (bvState.bottom_module_system) {
      bvState.bottom_module_system = JSON.parse(decodeURIComponent(bvState.bottom_module_system))
    }
    console.log('restoring bvState from url...', bvState);
    return bvState
  }

  /**
   *
   * @param bvState {object}
   * @param useNames {boolean}
   * @returns bvState {object}
   */
  addSpecificPropertiesToLocalStorage(bvState, useNames = false) {
    const cabinetParent = this.parts[Cabinet.id];
    const countertopGroupParent = this.parts[CountertopGroup.id];
    const wallsParent = this.parts[Walls.id];

    bvState.layout_type = this.type;
    Object.keys(bvState).forEach((bvStateKey) => {
      // console.log('bvStateKey', bvStateKey);
      switch(bvStateKey) {
        case "top_cabinet":
          // bvState["top_cabinet_parts"] = encodeURIComponent(JSON.stringify(cabinetParent.topCabinet.activeFeatureParts
          //   .filter(activeFeaturePart => activeFeaturePart)
          //   .map(activeFeaturePart => {
          //     return useNames ? activeFeaturePart.partName : activeFeaturePart.dbFeature.id
          //   })));
          if (!cabinetParent.topCabinet || !cabinetParent.topCabinet.activeFeatureParts) {
            break;
          }
          bvState["top_cabinet_parts"] = cabinetParent.topCabinet.activeFeatureParts
            .filter(activeFeaturePart => activeFeaturePart)
            .map(activeFeaturePart => {
              return useNames ? activeFeaturePart.partName : activeFeaturePart.dbFeature.id
            });
          if (cabinetParent.topCabinet.features.some(feature => feature.metaData["Module"])) { // disabled for now, but in case they are needed - change this condition!
            bvState["top_module_system"] = encodeURIComponent(JSON.stringify(cabinetParent.topCabinet.moduleSystem));
            bvState["inlay_types"] = encodeURIComponent(JSON.stringify(cabinetParent.topCabinet.inlayTypes));
          }
          break;
        case "bottom_cabinet":
          if (!cabinetParent.bottomCabinet || !cabinetParent.bottomCabinet.activeFeatureParts) {
            break;
          }
          // bvState["bottom_cabinet_parts"] = encodeURIComponent(JSON.stringify(cabinetParent.bottomCabinet.activeFeatureParts
          //   .filter(activeFeaturePart => activeFeaturePart)
          //   .map(activeFeaturePart => {
          //     return useNames ? activeFeaturePart.partName : activeFeaturePart.dbFeature.id
          //   })));
          bvState["bottom_cabinet_parts"] = cabinetParent.bottomCabinet.activeFeatureParts
            .filter(activeFeaturePart => activeFeaturePart)
            .map(activeFeaturePart => {
              return useNames ? activeFeaturePart.partName : activeFeaturePart.dbFeature.id
            });
          if (cabinetParent.bottomCabinet.features.some(feature => feature.metaData["Module"])) {
            bvState["bottom_module_system"] = encodeURIComponent(JSON.stringify(cabinetParent.bottomCabinet.moduleSystem));
          }
          break;
        case "crown_molding":
          if (!cabinetParent.crownMolding || !cabinetParent.crownMolding.activeFeatureParts) {
            break;
          }
          bvState["crown_molding_parts"] = cabinetParent.crownMolding.activeFeatureParts
            .filter(activeFeaturePart => activeFeaturePart)
            .map(activeFeaturePart => {
              return useNames ? activeFeaturePart.partName : activeFeaturePart.dbFeature.id
            });
          break;
        case "countertop":
          if (!countertopGroupParent.countertop || !countertopGroupParent.countertop.activeFeatureParts) {
            break;
          }
          bvState["countertop_parts"] = countertopGroupParent.countertop.activeFeatureParts
            .filter(activeFeaturePart => activeFeaturePart)
            .map(activeFeaturePart => {
              return useNames ? activeFeaturePart.partName : activeFeaturePart.dbFeature.id
            });
          break;
        case "backsplash":
          if (!wallsParent.backsplash) {
            break;
          }
          bvState["backsplash_type"] = wallsParent.backsplash.getCurrentActiveFeatureType();
          break;
        default:
          break;
      }
    });
    // console.log('bvState', bvState);
    return bvState
  }

  addNonVisualizerSubPart(featureGroupName){
    const otherParent = this.parts[Other.id];
    const partId = snakeCase(featureGroupName);
    let relatedItem = otherParent.relatedItems.find(relatedItem => relatedItem.partId === partId);
    if (!relatedItem) {
      relatedItem = new NonVisualizerSubPart(true, partId, featureGroupName);
      relatedItem.getParent = () => otherParent;
      otherParent.relatedItems.push(relatedItem);
    }
    return new DesignNavigationItem(relatedItem.partName, relatedItem)
  }

  get qtCategories() {

    if (!(Array.isArray(this.qtCategoriesList) && this.qtCategoriesList.length)) {
      return this.qtCategoriesList
    }

    // if (document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "KV") { // no need
    const currentLayoutAbbreviation = this.getCurrentLayoutAbbreviation();
    if (!currentLayoutAbbreviation.includes("I")) {
      const countertopParent = this.parts[CountertopGroup.id];
      const countertopSubParts = countertopParent && countertopParent.subParts();
      return this.qtCategoriesList.map(qtCategory => {
        let qtCategoryHasBeenChanged = false;
        const changedSubParts = qtCategory._subParts
          .map(subPart => {
            if (countertopSubParts) {
              switch (subPart.part.partId) {
                case "center_island_countertop":
                  qtCategoryHasBeenChanged = true;
                  return this.getChangedSubPart(countertopSubParts, subPart, "countertop");
                case "center_island_sink":
                  qtCategoryHasBeenChanged = true;
                  return this.getChangedSubPart(countertopSubParts, subPart, "sink");
                case "center_island_faucet":
                  qtCategoryHasBeenChanged = true;
                  return this.getChangedSubPart(countertopSubParts, subPart, "faucet");
                case "center_island_edge":
                  qtCategoryHasBeenChanged = true;
                  return this.getChangedSubPart(countertopSubParts, subPart, "edge_profile");
                case "center_island_stovetop":
                  qtCategoryHasBeenChanged = true;
                  return this.getChangedSubPart(countertopSubParts, subPart, "stovetop");
                default:
                  return subPart
              }
            }
            return subPart
          })
          .filter((subPart) => {
            return subPart && this.designNavigationItems(subPart, {}, "", false, true).length
          });
        if (qtCategoryHasBeenChanged) {
          qtCategory.subParts = changedSubParts;
          qtCategory.qtCategoryHasBeenChanged = true;
        }
        return qtCategory
      });
    }
    return this.qtCategoriesList.map((qtCategory) => {
      if (qtCategory.qtCategoryHasBeenChanged) {
        qtCategory.subParts = [...qtCategory.defaultSubParts];
        qtCategory.qtCategoryHasBeenChanged = false;
      }
      return qtCategory
    })
  }

  getChangedSubPart(allSubParts, currentSubPart, partId) {
    const newSubPart = allSubParts.find(cPart => cPart.part.partId === partId);
    if (!newSubPart) {
      return currentSubPart
    }
    // newSubPart.part.customGroupDisplayName = newSubPart.part.customGroupDisplayName || currentSubPart.part.customGroupDisplayName;
    return newSubPart
  }

  excludedIndexesFromHover = (layoutType) => {
    return [
      this.zIndexes[layoutType].Globals.Baseboard,  // exclude Globals
      this.zIndexes[layoutType].Globals.CeilingHighlights,  // exclude Globals
      this.zIndexes[layoutType].Globals.CeilingLights,  // exclude Globals
      this.zIndexes[layoutType].Globals.GlobalShadow,  // exclude Globals
      this.zIndexes[layoutType].Globals.Decor1,  // exclude Globals
      this.zIndexes[layoutType].Globals.Decor2,  // exclude Globals
      this.zIndexes[layoutType].Globals.Decor3,  // exclude Globals
      this.zIndexes[layoutType].Globals.Decor4,  // exclude Globals
      this.zIndexes[layoutType].Cabinet.TopCabinetShadow,  // exclude TopCabinetShadow
      this.zIndexes[layoutType].Cabinet.TopCabinetShadowPart2,  // exclude TopCabinetShadow
      this.zIndexes[layoutType].Cabinet.BottomCabinetShadow,  // exclude BottomCabinetShadow
      this.zIndexes[layoutType].CenterIsland.CenterIslandShadow,  // exclude CenterIslandShadow
      this.zIndexes[layoutType].CenterIsland.ChairsShadow,  // exclude CenterIslandShadow
      this.zIndexes[layoutType].Appliances.FridgeShadow,  // exclude FridgeShadow
      this.zIndexes[layoutType].Cabinet.TopCabinetModuleBox,  // exclude TopCabinetModuleBox
      this.zIndexes[layoutType].Cabinet.TopCabinetModuleBox2,  // exclude TopCabinetModuleBox2
      this.zIndexes[layoutType].Cabinet.BottomCabinetModuleBox,  // exclude BottomCabinetModuleBox
      this.zIndexes[layoutType].Cabinet.BottomCabinetModuleBox2,  // exclude BottomCabinetModuleBox2
    ]
  }

}
